import {buildDateFromString} from "@js/globalFunctions/dateHandling";

export function determineCurrentSearchArrivalStartAndEnd(){
	const arrival = searchParameters.getParameter('ankomst');
	if(arrival === undefined)
		return false;

	const arrivalDate = buildDateFromString(arrival);
	if(arrivalDate === false || !arrivalDate instanceof Date || isNaN(arrivalDate) )
		return false;

	let duration = searchParameters.getParameter('duration');
	if(duration === undefined)
		duration = 7;

	const endDate = new Date(arrivalDate.valueOf());
	endDate.setDate(arrivalDate.getDate()+Number(duration));

	return {start: arrivalDate, end: endDate};
}
